import moment from 'moment'

const authorizationStatus = [
  {
    text: 'homeV2.status.ready',
    value: 'READY',
  },
  {
    text: 'homeV2.status.approved',
    value: 'APPROVED',
  },
  {
    text: 'homeV2.status.rejected',
    value: 'REJECTED'
  },
  {
    text: 'homeV2.status.qualification',
    value: 'QUALIFICATION'
  },
  {
    text: 'homeV2.status.pendingReview',
    value: 'PENDING_REVIEW'
  },
  {
    text: 'homeV2.status.rejected',
    value: 'REJECTED'
  },
  {
    text: 'homeV2.status.claimed',
    value: 'CLAIMED'
  },
  {
    text: 'homeV2.status.voided',
    value: 'VOIDED'
  },
  {
    text: 'homeV2.status.notAttended',
    value: 'NOT_ATTENDED'
  },
  {
    text: 'homeV2.status.sentToSponsor',
    value: 'SENT_TO_SPONSOR'
  },
  {
    text: 'homeV2.status.paymentConfirmed',
    value: 'PAYMENT_CONFIRMED'
  },
  {
    text: 'homeV2.status.paid',
    value: 'PAID'
  }
]

const authorizationCoverage = [
  {
    text: 'homeV2.coverage.hospitalization',
    value: 'HOSPITALIZATION',
  },
]

export const filtersConfiguration = [
  {
    type: 'SELECT',
    text: 'homeV2.filters.coverage',
    items: authorizationCoverage,
    multipleSelection: true,
    section: 'v2',
    category: 'v2-coverage',
    mobile: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: 'SELECT',
    text: 'homeV2.filters.status',
    items: authorizationStatus,
    multipleSelection: true,
    section: 'v2',
    category: 'v2-status',
    mobile: true,
    customIcon: {
      required: true,
      icon: 'arrow_drop_down',
      iconClass: 'custom-icon-color'
    }
  },
  {
    type: "DATE-RANGE",
    text: 'homeV2.filters.date',
    items: null,
    multipleSelection: null,
    range: true,
    section: 'v2',
    category: "v2-date-range",
    mobile: true,
    minDate: null,
    maxDate: moment().format('YYYY-MM-DD'),
    customIcon: {
      required: true,
      icon: 'mdi-calendar',
      iconClass: 'custom-icon-color'
    }
  },
]

export const createAuthorizationActions = {
  ADDITIONAL_PRODUCTS: 'ADDITIONAL_PRODUCTS',
}

export const mimeTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg', 'text/plain', 'text/xml', 'application/xml']
